export const familyLedgerDetailKey = {
  all: ['familyLedgerDetail'] as const,
  detail: (personId: string, familyPersonId: string) => [...familyLedgerDetailKey.all, personId, familyPersonId] as const
} as const;